import * as Sentry from '@sentry/browser';

const SENTRY_DSN = 'https://9e5e1043d88dc477fc63e6ccb391b25b@o176251.ingest.us.sentry.io/4512052401733632';
const HOSTED_ORIGIN = 'https://meisterplan.dev';

export const initSentry = () => {
  if (window.location.origin !== HOSTED_ORIGIN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: true,
    environment: 'i12e',
    denyUrls: [
      // Browser extensions
      /safari-extension:\/\//i,
      /chrome-extension:\/\//i,
      /moz-extension:\/\//i,
      // Chrome dev tools console
      /^<anonymous>$/i,
    ],
    beforeSend: (event) => {
      if (JSON.stringify(event).includes('[NoSentryPlease]')) {
        console.log('Sentry event dropped because "[NoSentryPlease]" detected.', event);
        return null;
      }
      return event;
    },
  });
};
